import { reportUsageV2 } from '../../../api/usageV2';
import { loadProtobuf } from '../lazyExports';

import { SearchBeginProps } from './searchEvents.types';

const packageName = 'events';
const eventName = 'SearchBeginV1';

type ReportSearchBegin = (props: SearchBeginProps) => void;
export const reportSearchBegin: ReportSearchBegin = async ({
  beganSearchFrom,
  conversationId,
  isRefinement,
  language,
}) => {
  const { events } = await loadProtobuf();

  const searchBeginProps = {
    conversationId: conversationId ?? '',
    refinement: isRefinement,
    beganSearchFrom,
    language,
  };

  const threadDwellStartMessage = events.SearchBeginV1.encode(searchBeginProps).finish();

  reportUsageV2({
    packageName,
    eventName,
    value: threadDwellStartMessage,
  });
};
